import { format } from "date-fns";

export const convertDate = (date) => {
  const newDate = new Date(date);
  const formattedDate = format(newDate, "MMMM dd, yyyy");
  return formattedDate;
};

export const convertStringToDate = (date) => {
  if (date === null || date === undefined) {
    return;
  } else {
    const newDate = new Date(date);
    const formattedDate = format(newDate, "yyyy-MM-dd");
    return formattedDate;
  }
};
